export default {"src":"/_next/static/media/currency-circle-dollar.231f968d.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};